import { render, staticRenderFns } from "./Gallery26.vue?vue&type=template&id=6ce8c6c2&scoped=true&"
import script from "./Gallery26.vue?vue&type=script&lang=js&"
export * from "./Gallery26.vue?vue&type=script&lang=js&"
import style0 from "./Gallery26.vue?vue&type=style&index=0&id=6ce8c6c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce8c6c2",
  null
  
)

export default component.exports